// Fonction pour masquer les éléments par leur classe /// utiliser sur le block newsletter footer et section newsletter
// et mis en place sur le breadcrumb mais à optimiser pour supprimer le code.
function hideElementsByClass(className) {
  var elements = document.getElementsByClassName(className);
  for (var i = 0; i < elements.length; i++) {
  elements[i].style.display = 'none';
  }
}
function showElementsByClass(className) {
  var elements = document.getElementsByClassName(className);
  for (var i = 0; i < elements.length; i++) {
  elements[i].style.display = '';
  }
}
function checkScreenSize() {
  var width = window.innerWidth;
  showElementsByClass('smallHide');
  showElementsByClass('mediumHide');
  showElementsByClass('largupHide');
  if (width <= 749) {
    hideElementsByClass('smallHide');
  } else if (width >= 750 && width <= 989) {
    hideElementsByClass('mediumHide');
  } else if (width >= 990) {
    hideElementsByClass('largupHide');
  }
}
checkScreenSize();
window.addEventListener('resize', checkScreenSize);

// Fonction pour supprimer les videos sur les medias mobile avec la class mobileRemove 
// utiliser sur la bannière vidéo de la page d'accueil
function isMobile() {
    return /Mobi|Android/i.test(navigator.userAgent);
}
if (isMobile()) {
  var elements = document.querySelectorAll('.mobileRemove');
  elements.forEach(function(element) {
      element.remove();
  });
}


document.addEventListener('DOMContentLoaded', function() {
  // Calculer la hauteur totale des éléments .shopify-section-group-header-group
  // pour soustraire au 100vh de la 1ere section bannière image ou vidéo de la page d'accueil
  var elements = document.querySelectorAll('.shopify-section-group-header-group');
  var totalHeight = 0;
  elements.forEach(function(element) {
    totalHeight += element.offsetHeight;
  });
  document.documentElement.style.setProperty('--header-group-height', totalHeight + 'px');
  console.log('Total height:', totalHeight);

  // Calculer la hauteur du bouton avec l'identifiant partiel "BuyButtonFixedProduct-"
  var buyButtonFixed = document.querySelector('[id^="BuyButtonFixedProduct-"]');
  if (buyButtonFixed) {
    var buttonFixedHeight = buyButtonFixed.offsetHeight;
    document.documentElement.style.setProperty('--button-fixed-height', buttonFixedHeight + 'px');
    console.log('Button fixed height:', buttonFixedHeight);
  }
});

